export enum EIdlPrestationLineCategory {
	actes = "Actes",
	majorations = "Majorations",
	indemnites = "Indemnités"
}
